import type { AppRedirect } from '#src/shared/routes';

export const REDIRECTS: readonly AppRedirect[] = [
	{
		path: '/decision-makers/:slug/edit',
		// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
		buildUrl: ({ params: { slug }, queryString }) => `/admin/decision-makers/${slug!}/edit${queryString}`,
		reason: 'page-moved',
		permanent: true,
	},
];
